export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Découvrir des randonnées autour du globe !"])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trouver plus de trails"])}
}